<!--
 * @Description: 弹窗模块
 * @Autor: lwq
 * @Date: 2020-08-15 14:42:46
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-01-19 17:52:55
 * @FilePath: \mrc-base-server-view\src\views\data-access-strategy\modules\viewDataOfSubordinates\dialogModule.vue
-->
<template>
  <mrc_ess_myDialog :isopen='isopen'
                    @cancel='cancel'
                    @success='success'
                    width="50vw"
                    :title='title'
                    :disabled='true'>
    <mrc_ess_prompt :errMsg="$errors('params','name',requiredRule)"
                    :rules="false"
                    :label="$t('label_With_function_name')"
                    class="mt-5"
                    :placeholeder="$t('label_The_name_of_the_function')"
                    obj='language_client'
                    v-model="params.name">
    </mrc_ess_prompt>
  </mrc_ess_myDialog>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
export default {
  components: {},
  props: {
    title: {
      type: String,
    },
    isopen: {
      type: Boolean,
      default: false
    },
    paramsData: {
      type: Object,
      default: () => { }
    }
  },
  model: {
    prop: 'isopen',
    event: 'flag'
  },
  data () {
    return {
      params: {
        name: ''
      }
    };
  },
  validations: {
    params: {
      name: {
        required
      }
    }
  },
  computed: {},
  created () { },
  watch: {},
  mounted () { },

  methods: {
    cancel () {
      this.$emit('flag', !this.isopen)
      this.$emit('cancel')
    },
    success () {
      this.$v.params.$touch()
      if (this.$v.params.$error) return
      this.$emit('getData', this.params)
      this.$emit('flag', !this.isopen)
    },
  },
};
</script>

<style scoped>
</style>
